import ButtonType2 from "../../../components/ButtonType2/ButtonType2";
import ButtonType1 from "../../../components/ButtonType1/ButtonType1";
import ItemCard from "../../../components/ItemCard/ItemCard";
import { collectionitems } from "../../../data/collectionitems";

const Discover = () => {
    return(
        <div className="flex flex-col">
            <div className="flex flex-wrap justify-between items-center mb-5">
                <h2 className="mb-3 font-[500] text-center text-2xl md:text-3xl lg:text-4xl tracking-wide">
                    Discover
                </h2>
                <div className="flex flex-wrap items-center">
                    <select className="mb-3 bg-transparent text-white text-sm sm:text-base lg:text-lg mr-3 md:mr-6">
                        <option className = 'text-black' value="cheapest">Cheapest</option>
                        <option className = 'text-black' value="250-5000">250 to 5000</option>
                        <option className = 'text-black' value="5000-25000">5000 to 25000</option>
                        <option className = 'text-black' value="25000-100000">25000 to 100,000</option>
                        <option className = 'text-black' value=">100000">Above 100000</option>
                    </select>
                    <select className="mb-3 bg-transparent text-white text-sm sm:text-base lg:text-lg mr-3 md:mr-6">
                        <option value="newest">Newest</option>
                    </select>
                    <ButtonType2 title = 'Filter' className='mb-3 text-sm sm:text-base sm:w-[150px] h-[50px]' />
                </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 justify-items-center mb-10">
                {collectionitems.map((item, index) => {
                    return(
                        <ItemCard item={item} key = {index} className = "m-4 max-w-[300px]" />
                    )
                })}
            </div>

            <div className="w-full flex justify-center">
                <ButtonType1 title = 'Load More' />
            </div>

        </div>
    )
}

export default Discover;